/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { OMAN_TITLE, OMAN_DESCRIPTION } from '../../Utils/Constants/SEO';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import { OMAN_NAME } from '../../Utils/Constants/GlobalConstants';
import { getCountry } from '../../Utils/CommonUtils';
import { getCurrentYear } from '../../Utils/DateUtil';

class Oman extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = () => (
    <div>
      <div className="content_block">
        <h1 className="text_h1">{`Туры в Оман из Минска ${getCurrentYear()}: Восточная Сказка с Прямыми Рейсами Belavia!`}</h1>
        <p className="text_p">
          Откройте Оман — страну контрастов, где пустыни встречают океан, а
          древние крепости соседствуют с роскошными отелями.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">
          {`✅ Почему Оман? 5 причин выбрать отдых в ${getCurrentYear()} году`}
        </h2>
        <p className="text_p">Прямые рейсы из Минска</p>
        <p className="text_p">
          Чартеры Belavia в Салалу (7 ч 10 мин в пути), багаж 14 кг + 5 кг
          ручная кладь.
        </p>
        <p className="text_p">
          Туры на 8–11 ночей с отдыхом на пляжах уровня "Мальдив".
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Безопасность и гостеприимство</h2>
        <p className="text_p">
          3-е место в рейтинге безопасности MENA, нулевая преступность,
          доброжелательные жители. Уникальная природа
        </p>
        <p className="text_p">
          Горы с каньонами, бирюзовые пляжи, пустыня Вахиба, пальмовые оазисы и
          даже фьорды! Зеленый сезон в Салале (июнь–сентябрь) преображает
          ландшафты водопадами.
        </p>
        <p className="text_p">Культура без "небоскребного" гламура.</p>
        <p className="text_p">
          Аутентичные рынки, мечети в традиционном стиле, чаепития в мажлис. В
          Маскате все здания строятся по канонам арабской архитектуры.
        </p>
        <p className="text_p">
          Лучший сезон: октябрь–апрель. Температура +26...+35°C, сухо, минимум
          волн. Зимой в Салале теплее, чем в ОАЭ или Египте!
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">🏖 Курорты Омана: Где отдыхать?</h2>
        <p className="text_p">
          Туры с отдыхом на великолепных пляжах курорта Салала
          продолжительностью от 9 до 11 ночей, сформированные на прямых
          чартерных рейсах авиакомпании "Белавиа" от белорусских туроператоров.
          Чем знаменит курорт Салала? Пляжи с белым песком (Аль-Мугсайл с
          природными бассейнами), сезон дождей летом ("зеленые горы"). Идеален
          для дайвинга и наблюдения за дельфинами.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">
          ✨ Заключение: Оман — не просто отдых, а путешествие в тысячу и одну
          ночь!
        </h2>
        <p className="text_p">
          {`Прямые рейсы из Минска, безопасность и контрасты природы делают Оман
          топ-направлением ${getCurrentYear()}!`}
        </p>
        <p className="text_p">
          Откройте Восток без стереотипов — с проверенными туроператорами
          Беларуси на сайте tourhunter.by.
        </p>
      </div>
    </div>
  );

  render() {
    const text = this.getText();
    return (
      <div className="content">
        <Helmet>
          <title>{OMAN_TITLE}</title>
          <meta name="description" content={OMAN_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/oman/" />
          <meta property="og:title" content={OMAN_TITLE} />
          <meta property="og:description" content={OMAN_DESCRIPTION} />

          <link rel="canonical" href="https://tourhunter.by/oman/" />
        </Helmet>
        <ToursResultFunc countryFilter={getCountry(OMAN_NAME)} text={text} />
      </div>
    );
  }
}

export default Oman;
